<template>
  <div class="chat-admin">
    <div class="admin-header">
      <h1>Painel de Chat - MASTER</h1>
      <div class="admin-stats">
        <div class="stat-card">
          <div class="stat-value">{{ totalRooms }}</div>
          <div class="stat-label">Conversas</div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ totalMessages }}</div>
          <div class="stat-label">Mensagens</div>
        </div>
      </div>
    </div>

    <div class="admin-body">
      <div class="rooms-panel">
        <div class="panel-header">
          <h2>Conversas</h2>
          <input v-model="searchQuery" @input="searchRooms" placeholder="Buscar..." class="search-input" />
        </div>

        <div v-if="loading" class="loading">Carregando...</div>

        <div v-else class="rooms-list">
          <div
            v-for="room in rooms"
            :key="room.id"
            @click="selectRoom(room)"
            class="room-card"
            :class="{ active: selectedRoom && selectedRoom.id === room.id }"
          >
            <div class="room-avatar">{{ room.name[0] }}</div>
            <div class="room-info">
              <div class="room-name">{{ room.name }}</div>
              <div class="room-users">
                {{ room.users.map(function(u) { return u.nome }).join(', ') }}
              </div>
            </div>
          </div>

          <div v-if="rooms.length === 0" class="empty">Nenhuma conversa</div>
        </div>
      </div>

      <div class="messages-panel">
        <div v-if="!selectedRoom" class="empty-state">
          <p>Selecione uma conversa</p>
        </div>

        <div v-else class="messages-view">
          <div class="messages-header">
            <button @click="selectedRoom = null" class="back-btn">←</button>
            <h3>{{ selectedRoom.name }}</h3>
            <button @click="exportMessages" class="export-btn">Exportar</button>
          </div>

          <div class="messages-container" ref="messagesContainer">
            <div v-if="loadingMessages" class="loading">Carregando...</div>

            <div v-else>
              <div v-for="msg in messages" :key="msg.id" class="message-item">
                <div class="message-header">
                  <div class="sender-avatar">{{ msg.sender.nome[0] }}</div>
                  <div class="sender-info">
                    <strong>{{ msg.sender.nome }}</strong>
                    <span class="message-time">{{ formatDateTime(msg.timestamp) }}</span>
                  </div>
                </div>
                <div class="message-content">{{ msg.content }}</div>
              </div>

              <div v-if="messages.length === 0" class="empty">Nenhuma mensagem</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ChatAdmin',
  data: function () {
    return {
      rooms: [],
      messages: [],
      selectedRoom: null,
      searchQuery: '',
      loading: false,
      loadingMessages: false,
      searchTimeout: null,
      totalRooms: 0,
      totalMessages: 0
    }
  },
  mounted: function () {
    this.loadRooms()
  },
  methods: {
    loadRooms: function () {
      var self = this
      this.loading = true

      var token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')

      axios.get('/api/chat/rooms', {
        params: { q: this.searchQuery || undefined },
        headers: { 'Authorization': 'Bearer ' + token }
      })
        .then(function (response) {
          self.rooms = response.data || []
          self.totalRooms = self.rooms.length
          self.loading = false
        })
        .catch(function (error) {
          console.error('Erro ao carregar salas:', error)
          self.loading = false
          self.rooms = []
        })
    },

    searchRooms: function () {
      var self = this
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(function () {
        self.loadRooms()
      }, 500)
    },

    selectRoom: function (room) {
      this.selectedRoom = room
      this.loadMessages(room.id)
    },

    loadMessages: function (roomId) {
      var self = this
      this.loadingMessages = true

      var token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token')

      axios.get('/api/chat/rooms/' + roomId + '/messages', {
        params: { limit: 100 },
        headers: { 'Authorization': 'Bearer ' + token }
      })
        .then(function (response) {
          self.messages = response.data || []
          self.totalMessages = self.messages.length
          self.loadingMessages = false

          self.$nextTick(function () {
            self.scrollToBottom()
          })
        })
        .catch(function (error) {
          console.error('Erro ao carregar mensagens:', error)
          self.loadingMessages = false
          self.messages = []
        })
    },
    scrollToBottom: function () {
      var container = this.$refs.messagesContainer
      if (container) {
        container.scrollTop = container.scrollHeight
      }
    },

    exportMessages: function () {
      if (!this.selectedRoom) return

      var text = 'CONVERSA: ' + this.selectedRoom.name + '\n'
      text += 'DATA: ' + new Date().toLocaleString('pt-BR') + '\n\n'

      this.messages.forEach(function (msg) {
        text += '[' + new Date(msg.timestamp).toLocaleString('pt-BR') + '] '
        text += msg.sender.nome + ': '
        text += msg.content + '\n'
      })

      var blob = new Blob([text], { type: 'text/plain' })
      var url = URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = 'chat-' + this.selectedRoom.id + '.txt'
      a.click()
      URL.revokeObjectURL(url)
    },

    formatDateTime: function (dateString) {
      return new Date(dateString).toLocaleString('pt-BR')
    }
  }
}
</script>

<style scoped>
.chat-admin {
  padding: 20px;
  /* NÃO usa max-width para respeitar o container pai */
}

.admin-header {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 20px 24px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.admin-header h1 {
  margin: 0 0 16px 0;
  font-size: 20px;
}

.admin-stats {
  display: flex;
  gap: 16px;
}

.stat-card {
  background: rgba(255,255,255,0.2);
  padding: 12px 20px;
  border-radius: 6px;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  margin-top: 4px;
}

.admin-body {
  display: flex;
  gap: 16px;
  /* Usa altura fixa calculada */
  height: 600px;
}

.rooms-panel {
  width: 320px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.messages-panel {
  flex: 1;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.panel-header {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
}

.panel-header h2 {
  margin: 0 0 10px 0;
  font-size: 15px;
}

.search-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
  font-size: 13px;
}

.search-input:focus {
  border-color: #667eea;
}

.rooms-list {
  flex: 1;
  overflow-y: auto;
}

.room-card {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
  transition: background 0.2s;
}

.room-card:hover {
  background: #f9f9f9;
}

.room-card.active {
  background: #f0f4ff;
  border-left: 3px solid #667eea;
}

.room-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  flex-shrink: 0;
}

.room-info {
  flex: 1;
  min-width: 0;
}

.room-name {
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.room-users {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.empty-state, .empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 13px;
  padding: 20px;
  text-align: center;
}

.messages-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.messages-header {
  padding: 10px 12px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fafafa;
}

.back-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  padding: 4px 6px;
  color: #667eea;
}

.messages-header h3 {
  margin: 0;
  font-size: 14px;
  flex: 1;
}

.export-btn {
  padding: 6px 12px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
}

.export-btn:hover {
  background: #5568d3;
}

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
}

.message-item {
  margin-bottom: 12px;
  padding: 8px 10px;
  background: #f9f9f9;
  border-radius: 6px;
}

.message-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.sender-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 11px;
  flex-shrink: 0;
}

.sender-info {
  flex: 1;
}

.sender-info strong {
  font-size: 12px;
}

.message-time {
  font-size: 10px;
  color: #999;
  margin-left: 6px;
}

.message-content {
  font-size: 12px;
  line-height: 1.4;
  margin-left: 32px;
  word-wrap: break-word;
}

.loading {
  padding: 30px;
  text-align: center;
  color: #999;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// ChatMasterPage.vue?25c9ce8f